import React, { Component } from 'react';
import WorkFlowTemplate from '../../common/workFlowTemplate'
import SideNav from '../SideNav';

class WorkFlow extends Component {
    render() {
        return (
            <div className="content">
                <SideNav selectKey='siteStart'/>
                <div className="main">
                    <WorkFlowTemplate />
                </div>  
            </div>
        );
    }
}

export default WorkFlow;


// WEBPACK FOOTER //
// ./src/components/invStartUp/workFlow/index.js